import { CrudSettings } from '@app/models/CrudSettings';
import { createContext } from 'react';

type CrudSettingsContextType = {
  settings: CrudSettings;
  // eslint-disable-next-line @typescript-eslint/ban-types
  setSettings: Function;
};

export const CrudSettingsContext = createContext<CrudSettingsContextType | undefined>(undefined);
